import React from 'react';

export default function FichaTecnicaIndicadoresPage() {
  return (
    <div>
      Qualidade - Ficha Técnica de Indicadores (placeholder).
    </div>
  );
}

